// A revealed hand's waits, as the exhaustive draw's result shows them (audit 2026-10-14): the kinds that complete
// the concealed tiles as four sets and a pair (with the melds made up), seven pairs or thirteen orphans. The core
// decides tenpai (mjcore/src/algo/shape.cpp); this only names the tiles, so a kind the hand holds all four of
// (it can't be drawn) is left out.

import { kindOf } from "./tiles";

const KINDS = 34;
const ORPHANS = [0, 8, 9, 17, 18, 26, 27, 28, 29, 30, 31, 32, 33];

/** Whether the counts split into sets only (a pair already taken out). */
function sets(c: number[], from = 0): boolean {
  let i = from;
  while (i < KINDS && c[i] === 0) i++;
  if (i === KINDS) return true;
  if (c[i]! >= 3) {
    c[i]! -= 3;
    const ok = sets(c, i);
    c[i]! += 3;
    if (ok) return true;
  }
  if (i < 27 && i % 9 <= 6 && c[i + 1]! > 0 && c[i + 2]! > 0) {
    c[i]!--, c[i + 1]!--, c[i + 2]!--;
    const ok = sets(c, i);
    c[i]!++, c[i + 1]!++, c[i + 2]!++;
    if (ok) return true;
  }
  return false;
}

function complete(c: number[]): boolean {
  const n = c.reduce((a, b) => a + b, 0);
  for (let p = 0; p < KINDS; p++) {
    if (c[p]! < 2) continue;
    c[p]! -= 2;
    const ok = sets(c);
    c[p]! += 2;
    if (ok) return true;
  }
  if (n !== 14) return false;
  if (c.every((x) => x === 0 || x === 2)) return true; // seven pairs: seven different kinds
  return ORPHANS.every((k) => c[k]! >= 1) && ORPHANS.some((k) => c[k] === 2);
}

/** The kinds (0..33) completing these concealed tiles, in order. */
export function waits(ids: readonly number[]): number[] {
  const c = new Array<number>(KINDS).fill(0);
  for (const id of ids) c[kindOf(id)]!++;
  if (ids.length % 3 !== 1) return [];
  const out: number[] = [];
  for (let k = 0; k < KINDS; k++) {
    if (c[k] === 4) continue;
    c[k]!++;
    if (complete(c)) out.push(k);
    c[k]!--;
  }
  return out;
}
